import { render } from "./basecard.vue?vue&type=template&id=8e615760&scoped=true"
import script from "./basecard.vue?vue&type=script&lang=js"
export * from "./basecard.vue?vue&type=script&lang=js"

import "./basecard.vue?vue&type=style&index=0&id=8e615760&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e615760"]])

export default __exports__